import React, { FC } from 'react';

import { INotificationManager } from 'src/contexts/NotificationContextBase/types';
import { ErrorList } from 'src/elements/ErrorList';
import { SuccessMessage } from 'src/elements/SuccessMessage';

export interface INotificationDisplay extends Partial<
  Pick<INotificationManager, 'errors' | 'notice'>
> {}

const Notifications: FC<INotificationDisplay> = ({ errors, notice }) => {
  return (
    <>
      {notice && <SuccessMessage message={notice} />}
      {errors && <ErrorList messages={errors} />}
    </>
  );
};

export default Notifications;
